// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SimilarBooks_container__OzDVW {
  width: 100%;
}
.SimilarBooks_similarBooks__NLLMM {
  width: 95%;
  max-width: 1400px;
  position: relative;
  margin: auto;
}

.SimilarBooks_similarBooksTitle__Nn5pj {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 20px;
  color: white;
}

.SimilarBooks_swiper__iLSCR {
  width: 100%;
  height: 100%;
  padding-bottom: 4rem;
}

.SimilarBooks_swiperSlide__rUPUq {
  display: flex;
  justify-content: center;
  align-items: center;
}

.SimilarBooks_bookCard__huoHi {
  width: 100%;
  height: 100%;
  border-radius: 8px;
  overflow: hidden;
  transition: transform 0.3s ease;
}

.SimilarBooks_bookCard__huoHi:hover {
  transform: scale(1.05);
}

.SimilarBooks_bookCover__cZeUY {
  width: 100%;
  height: 100%;
  object-fit: cover;
  cursor: pointer;
}

/* Custom navigation styles */
.swiper-button-next,
.swiper-button-prev {
  color: #333;
  background-color: rgba(255, 255, 255, 0.8);
  width: 35px;
  height: 35px;
  border-radius: 50%;
}

.swiper-button-next:after,
.swiper-button-prev:after {
  font-size: 16px;
  font-weight: bold;
}

.swiper-button-next:hover,
.swiper-button-prev:hover {
  background-color: rgba(255, 255, 255, 0.95);
}

/* Hide navigation on mobile */
@media (max-width: 768px) {
  .swiper-button-next,
  .swiper-button-prev {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/reading-pages/view/SimilarBooks.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;AACb;AACA;EACE,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,eAAe;AACjB;;AAEA,6BAA6B;AAC7B;;EAEE,WAAW;EACX,0CAA0C;EAC1C,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;;EAEE,eAAe;EACf,iBAAiB;AACnB;;AAEA;;EAEE,2CAA2C;AAC7C;;AAEA,8BAA8B;AAC9B;EACE;;IAEE,aAAa;EACf;AACF","sourcesContent":[".container {\n  width: 100%;\n}\n.similarBooks {\n  width: 95%;\n  max-width: 1400px;\n  position: relative;\n  margin: auto;\n}\n\n.similarBooksTitle {\n  font-size: 24px;\n  font-weight: bold;\n  margin-bottom: 20px;\n  color: white;\n}\n\n.swiper {\n  width: 100%;\n  height: 100%;\n  padding-bottom: 4rem;\n}\n\n.swiperSlide {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.bookCard {\n  width: 100%;\n  height: 100%;\n  border-radius: 8px;\n  overflow: hidden;\n  transition: transform 0.3s ease;\n}\n\n.bookCard:hover {\n  transform: scale(1.05);\n}\n\n.bookCover {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  cursor: pointer;\n}\n\n/* Custom navigation styles */\n:global(.swiper-button-next),\n:global(.swiper-button-prev) {\n  color: #333;\n  background-color: rgba(255, 255, 255, 0.8);\n  width: 35px;\n  height: 35px;\n  border-radius: 50%;\n}\n\n:global(.swiper-button-next:after),\n:global(.swiper-button-prev:after) {\n  font-size: 16px;\n  font-weight: bold;\n}\n\n:global(.swiper-button-next:hover),\n:global(.swiper-button-prev:hover) {\n  background-color: rgba(255, 255, 255, 0.95);\n}\n\n/* Hide navigation on mobile */\n@media (max-width: 768px) {\n  :global(.swiper-button-next),\n  :global(.swiper-button-prev) {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `SimilarBooks_container__OzDVW`,
	"similarBooks": `SimilarBooks_similarBooks__NLLMM`,
	"similarBooksTitle": `SimilarBooks_similarBooksTitle__Nn5pj`,
	"swiper": `SimilarBooks_swiper__iLSCR`,
	"swiperSlide": `SimilarBooks_swiperSlide__rUPUq`,
	"bookCard": `SimilarBooks_bookCard__huoHi`,
	"bookCover": `SimilarBooks_bookCover__cZeUY`
};
export default ___CSS_LOADER_EXPORT___;
